import React from "react";
import moment from "moment";
import Select from "react-select";

import NumberFormat from "react-number-format";
import { Button } from "react-bootstrap";
import { Scrollbars } from "react-custom-scrollbars";

import TableLoader, { TableColumn, TableRow } from "components/Table/Table.js";

import styles from "./style.module.css";

export default class ProjectRow extends React.PureComponent {
  render() {
    const { project, onClick, isHighlight, onHover, history } = this.props;

    const noPermissions = !project.segment_count;

    return (
      <TableRow>
        <TableColumn>{noPermissions ? project.name : <a onClick={() => onClick()}>{project.name}</a>}</TableColumn>
        <TableColumn title={moment.utc(project.created).local().format("MMMM Do YYYY, h:mm:ss a")}>
          {moment.utc(project.created).local().fromNow()}
        </TableColumn>
        <TableColumn>{project.roles ? project.roles.length : ""}</TableColumn>
        <TableColumn>{project.segment_count ? Math.max(project.segment_count - 1, 1) : "No Access"}</TableColumn>
        <TableColumn>{project.created_by ? project.created_by.fullname : ""}</TableColumn>
        <TableColumn>
          <div className={styles.capitalize}>{project.status}</div>
        </TableColumn>
      </TableRow>
    );
  }
}
